import { render, staticRenderFns } from "./simpleTextLayerDrawerV.vue?vue&type=template&id=3e395447&"
import script from "./simpleTextLayerDrawerV.vue?vue&type=script&lang=ts&"
export * from "./simpleTextLayerDrawerV.vue?vue&type=script&lang=ts&"
import style0 from "./simpleTextLayerDrawerV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports